module.exports = __webpack_public_path__ + "static/footerLogo-24e731cbf761eda5d0c43988475587f2.png";